import { getServerConfig } from '@configs/envServerConfig'
import { getRewardBearerTokenBody } from '@configs/reward.config'
import { HEADER_JSON_CONTENT } from '@constants/communication'
import {
  ASSET_REWARD_FETCH_TIMEOUT,
  FETCH_ASSET_REWARDS_ENDPOINT,
  FETCH_REWARDS_ENDPOINT,
  FETCH_USER_ID,
  OAUTH_GENERATE_TOKEN_ENDPOINT,
} from '@constants/rewards'
import { fetchWithTimeout } from '@utils/utils'

export default class RewardServiceApi {
  static async fetchRewards({ userIdNumeric, bearerToken }) {
    const config = process.env.ACKO_ENV
    const url = `${getServerConfig(config)?.rewardsServiceUrl}${FETCH_REWARDS_ENDPOINT}?user_id=${userIdNumeric}`
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    }
    const response = await fetch(url, {
      method: 'GET',
      headers,
    })
    return response
  }

  static async getBearerToken() {
    const config = process.env.ACKO_ENV
    const url = `${getServerConfig(config)?.authTokenServiceUrl}${OAUTH_GENERATE_TOKEN_ENDPOINT}`

    const body = new URLSearchParams(getRewardBearerTokenBody(config))

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    })
    if (response.ok) {
      const res = await response.json()
      return res?.access_token
    } else {
      throw Error('Unable to update Bearer token for rewards')
    }
  }

  static async getUserIdNumeric(userId) {
    const config = process.env.ACKO_ENV
    const url = `${getServerConfig(config)?.entityService}${FETCH_USER_ID}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Cookie: `user_id=${userId}`,
        },
      })
      const data = await response.json()
      if (data?.id) {
        return data.id
      }
      return null
    } catch (ex) {
      console.log('User Service Error', ex)
    }
  }

  static async getUserData(userId) {
    const config = process.env.ACKO_ENV
    const url = `${getServerConfig(config)?.entityService}${FETCH_USER_ID}`

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Cookie: `user_id=${userId}`,
        },
      })

      const data = await response.json()
      console.log('===>getUserData', url, data)
      if (data) {
        return data.ekey
      }
      return null
    } catch (ex) {
      console.log('User Service Error', ex)
    }
  }

  static async getAssetCouponsForCoupon({ couponId, userIdNumeric, bearerToken }) {
    const config = process.env.ACKO_ENV
    const url = `${
      getServerConfig(config)?.rewardsServiceUrl
    }${FETCH_ASSET_REWARDS_ENDPOINT}/${couponId}?user_id=${userIdNumeric}`

    const options = {
      method: 'GET',
      headers: {
        ...HEADER_JSON_CONTENT,
        Authorization: `Bearer ${bearerToken}`,
      },
      timeout: ASSET_REWARD_FETCH_TIMEOUT,
    }

    try {
      const response = await fetchWithTimeout(url, options)
      const data = await response.json()
      return data?.asset_coupons || []
    } catch (ex) {
      console.error('Asset reward service error', ex)
      return []
    }
  }
}
